<template>
<v-container>
  <v-data-table
    :headers="headers"
    :items="contractItems"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="ContractItem-button-new"
          @click="$router.push({
            name: 'contracts-EditContractItem'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'contracts-EditContractItem',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListContractItem',
  module: 'Contracts',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('contractItems', ['contractItems']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('description'),
          value: 'description',
        },
        {
          text: this.$$t('quantity'),
          value: 'quantity',
        },
        {
          text: this.$$t('amount'),
          value: 'amount',
        },
        {
          text: this.$$t('total'),
          value: 'total',
        },
        {
          text: this.$$t('bankAccount'),
          value: 'bankAccount',
        },
        {
          text: this.$$t('account'),
          value: 'account',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_contractItems();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('contractItems', ['LOAD_contractItems', 'DELETE_contractItem']),
    /** Delete ContractItem from the collection
     */
    async remove(contractItem) {
      this.isLoading = true;
      await this.DELETE_contractItem(contractItem.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# ContractItem example

'''js
<ContractItem />
'''
</docs>
